import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import "../Dynamic/WarehouseOffCanvas.scss";
import { InventoryApiService } from '../../Service/InventoryApiService';
import { CommonService } from '../../Service/CommonService';

interface WarehouseOffCanvasProps {
    type: string,
    warehouseName?: string,
    palletId?: string,
    locationId?: string,
    warehouseId?: string,
    onClose: () => void; 
}

const WarehouseOffCanvas: React.FC<WarehouseOffCanvasProps> = ({
    type, warehouseName, palletId, locationId, warehouseId, onClose
}) => {

    const [viewOffCanvas, setViewOffCanvas] = useState(false);
    const [palletDetails, setPalletDetails] = useState<any>(null);
    const [locationDetails, setLocationDetails] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeButton, setActiveButton] = useState<string>("pallets");
    const [barrelDetails, setBarrelDetails] = useState([]);

    const handleCloseOffCanvas = () => {
        setViewOffCanvas(false);
        onClose(); // 👈 Notify parent
    };

    const fetchPalletDetails = async () => {
        setIsLoading(true);
        try {
            const response = await InventoryApiService.getPalletDetailsById(palletId);
            setPalletDetails(response.data);
        } catch (error) {
            console.log("Error occurred while api calling " + error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchBarrelDetailsByLocation = async() => {
        setIsLoading(true);
        try {
            const response = await InventoryApiService.getBarrelDetailsByLocation(locationId, warehouseName);
            setBarrelDetails(response.data);
        } catch(error) {
            console.log("error occurred while api calling " + error);
        } finally {
            setIsLoading(false);
        }
    }

    const fetchLocationDetails = async () => {
        setIsLoading(true);
        try {
            const response = await InventoryApiService.getPalletWithBarrelDetails(
                warehouseName, locationId
            );
            setLocationDetails(response.data);
        } finally {
            setIsLoading(false);
        }
    };

    const isStagingArea = (): boolean => {

        if(!locationId){
            return false;
        }
        // matches: number_number (ex: 9_1, 12_3, 100_45)
        const digitUnderscorePattern = /^\d+_\d+$/;

        return !digitUnderscorePattern?.test(locationId?.trim());
    };


    // open every time component is mounted OR props change
    useEffect(() => {
        console.log(locationId);
        setViewOffCanvas(true);
        setActiveButton("pallets");
    }, [type, palletId, locationId, warehouseId]);

    useEffect(() => {
        if (!viewOffCanvas) return;

        if (type === "pallet") {
            fetchPalletDetails();
        } else {
            fetchLocationDetails();
        }
    }, [type, viewOffCanvas, palletId, locationId, warehouseName]);

    return (
        <>
            {/* <button onClick={handleCloseOffCanvas}>Show Sidebar</button> */}

            {viewOffCanvas && (
                <div className={`warehouse-offcanvas-wrapper ${type === 'pallet' ? "pallet-detail" : ""}`}>
                    <div className="warehouse-panel-left" onClick={handleCloseOffCanvas}></div>

                    <div className="warehouse-panel-inner">
                        <div className="header">
                            <div className="header-inner d-flex justify-content-between align-items-center">
                                <h3 className="main-heading mb-0">
                                    {type === "pallet" ? "Pallet Details" : "Details"}


                                </h3>

                                {isStagingArea() && (<div className="m-auto">
                                    <div
                                    className="btn-group user-activity-btn-grp flex-wrap"
                                    role="group"
                                    aria-label="Basic mixed styles example"
                                    >

                                    <button
                                        className={`tab-btn d-inline-flex justify-content-between align-items-center
                                            ${
                                            activeButton === "pallets"
                                                ? "bg-theme"
                                            : "bg-theme-white"
                                            }`}
                                        onClick={() => {
                                            setActiveButton("pallets");
                                            fetchLocationDetails();
                                        }}
                                    >
                                        Pallets
                                    </button>

                                    <button
                                        className={`tab-btn d-inline-flex justify-content-between align-items-center ${activeButton === "barrels" ? "bg-theme" : "bg-theme-white"}`}
                                        onClick={() => {
                                            setActiveButton("barrels");
                                            fetchBarrelDetailsByLocation();
                                        }}
                                    >
                                        Containers
                                    </button>
                                    </div>
                                    </div>)}

                                <button onClick={handleCloseOffCanvas} className="close-btn">
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>

                        <div className="warehouse-panel-body">
                            {isLoading && <p>Loading...</p>}
                            {type === "pallet" && palletDetails && (
                                <>
                                    {/* Header */}
                                    <div className="body-header flex-wrap gap-3">
                                        <div className="header-item">
                                            Pallet #: <span>{palletDetails.palletId}</span>
                                        </div>
                                        <div className="header-item">
                                            Containers: <span>{palletDetails.barrelCount}</span>
                                        </div>
                                        <div className="header-item">
                                            Creation Date: <span>{CommonService.formatDateForSupportRequest(palletDetails.createdDate)}</span>
                                        </div>
                                    </div>

                                    {/* Barrel table */}
                                    <div className="panel-body-inner">
                                    {palletDetails.barrelInfoResponse?.map((item: any, index: number) => (
                                        <div className="detail-item-wrapper">
                                            <table>
                                                <tbody>
                                                        <React.Fragment key={index}>
                                                            <tr>
                                                                <td>Distillery</td>
                                                                <td>{item.distillery}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Container Id</td>
                                                                <td>{item.barrelNumber}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Lot ID</td>
                                                                <td>{item.lotNo}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Owner</td>
                                                                <td>{item.ownerName}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            {!isLoading && type !== "pallet" && activeButton === "pallets" && (
                                <div className="panel-body-inner">
                                    {locationDetails?.length > 0 ? (
                                      locationDetails
                                        .sort((a: any, b: any) => a.level - b.level) // lowest level first
                                        .map((loc: any) => (
                                            <div className="stack-detail-item" key={loc.id}>

                                                {/* Stack Header */}
                                                <div className="detail-item-header">
                                                    <div className="header-item">
                                                        Location:{" "}
                                                        <span>
                                                            {loc.row == null && loc.stack == null
                                                                ? `Level ${loc.level != null ? loc.level : ""}`
                                                                : `${loc.row}-${loc.stack}-${loc.level}`}
                                                        </span>
                                                    </div>

                                                    <div className="header-item">
                                                        Pallet #: <span>{loc.palletId}</span>
                                                    </div>
                                                    <div className="header-item">
                                                        Creation Date: <span>{CommonService.formatDateForSupportRequest(loc.createdAt)}</span>
                                                    </div>
                                                </div>

                                                {/* Table */}
                                                <div className="table-responsive detail-table-wrapper">
                                                    <table className="service-detail-table mb-0 table">
                                                        <thead>
                                                            <tr>
                                                                <th>Container Id</th>
                                                                <th>Lot ID</th>
                                                                <th>Distillery</th>
                                                                <th>Owner</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {loc.barrelInfoList && loc.barrelInfoList.length > 0 ? (
                                                                loc.barrelInfoList.map((b: any, idx: number) => (
                                                                    <tr key={idx}>
                                                                        <td>{b.barrelNumber}</td>
                                                                        <td>{b.lotNo}</td>
                                                                        <td>{b.distillery}</td>
                                                                        <td>{b.ownerName}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="text-center">
                                                                        No Containers
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                      <p>No Records Found</p>
                                    )}
                                </div>
                            )}

                            {!isLoading && type !== "pallet" && activeButton === "barrels" && (
                                <div className="panel-body-inner">
                                    
                                            <div className="stack-detail-item">

                                                {/* Table */}
                                                <div className="table-responsive detail-table-wrapper">
                                                    <table className="service-detail-table mb-0 table">
                                                        <thead>
                                                            <tr>
                                                                <th>Container #</th>
                                                                <th>Lot ID</th>
                                                                <th>Distillery</th>
                                                                <th>Owner</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {barrelDetails?.length > 0 ? (
                                                                barrelDetails.map((b: any, idx: number) => (
                                                                    <tr key={b.barrelId ?? idx}>
                                                                        <td>{b.barrelNumber}</td>
                                                                        <td>{b.lotNo}</td>
                                                                        <td>{b.distillery}</td>
                                                                        <td>{b.ownerName}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="text-center">No containers found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                </div>
                            )}


                            {!isLoading && type === "pallet" && !palletDetails && (
                                <p>No Records Found</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default WarehouseOffCanvas;
